
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { QuickBooksLinkedService } from 'app/model/linkedservice/quick-books.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.quickBooks.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.QuickBooks_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.QuickBooks_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: QuickBooksLinkedService.MODEL // Linked service redefined
        }
    }
})
export class QuickBooksObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
